module.exports = __webpack_public_path__ + "img/Love_death_and_robots_Uniqueness.6bcebb76.webp";